import 'promise-polyfill/lib/polyfill';
import ShopifyProductProvider from './providers/ShopifyProductProvider';

export default class ProductService {
  constructor(type) {
    this._provider = null;
    switch (type.toLowerCase()) {
      case 'shopify': {
        this._provider = ShopifyProductProvider;
        break;
      }
      default:
        this._provider = ShopifyProductProvider;
    }
  }

  getProduct(handle) {
    return this._provider.getProduct(handle);
  }

  getRecommendedProduct(productId, limit) {
    return this._provider.getRecommendedProduct(productId, limit);
  }
}
